export default function() {
    this.loadCurrentData()
}
